import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { updateAskVyrillIntroModal } from "../Actions";
import "../../Tutorials/TutorialModalstyles.scss";
import "./AskVyrillIntro.scss";
import { updateNavStats } from "../../SharedActions";
import { fetchNavbarStats } from "../../../vyrill-ui-config/layout/sidebar/navbarStatsActions";

const newTagIcon =
  require(`@src/assets/images/vyrill/icons/new_tag.png`).default;

const AskVyrillIntro = ({}) => {
  const dispatch = useDispatch();

  const showIntro = useSelector(
    (state) => state.modalsState.askVyrillIntro.showIntro
  );

  const handleClose = () => {
    // API call to disable the modal
    updateNavStats(false)
      .then((response) => {
        if (response) {
          dispatch(fetchNavbarStats());
          dispatch(
            updateAskVyrillIntroModal({
              showIntro: false,
            })
          );
        }
      })
      .catch((err) => {});
  };

  if (showIntro) {
    return (
      <div className="tutorial-modal">
        <div className="AskVyrillIntro">
          <div className="UnleashModal">
            <div className="header">
              <div className="tag-image">
                <img src={newTagIcon} width={41} />
              </div>

              <div className="close-btn">
                <img
                  onClick={handleClose}
                  src={require("@src/assets/images/vyrill/cross.png").default}
                  alt=""
                  role="button"
                  width="25px"
                />
              </div>
            </div>
            <span className="top-heading">
              {" "}
              Unleash the power of Ask Vyrill!{" "}
            </span>
            <div className="description">
              Type in a specific question or click to select a prompt to{" "}
              <span className="pink-highlight">
                receive comprehensive responses
              </span>{" "}
              about your video analysis. Give it a try!
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default AskVyrillIntro;
